module.exports = "<div class=\"gw-carousel\">\n    <div uib-carousel slides=\"slides\" active-fn=\"activeFn\" interval=\"interval\" no-wrap=\"!wrapSlides\">\n        <gw-carousel-slides ng-transclude>\n        </gw-carousel-slides>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ../common/grunt/webpack/loaders/text-loader!../common/js/src/edge/platform/widgets/carousel/directives/templates/gw-carousel.html
// module id = 952
// module chunks = 0